import {
  AI_INTENTS,
  assertKnownIntent,
} from '../../constants/aiSearchIntents';


const DEFAULT_ACTIONS = [
  {
    id: 'create_psa',
    label: 'Create a Post',
    iconName: 'PenSquare',
    action: 'open-create-post',
    postType: 'psa',
    primary: true,
  },
];

export const INTENT_TO_ACTIONS = {
  [AI_INTENTS.MEDICAL_EMERGENCY]: [
  ],
  [AI_INTENTS.MEDICAL_ROUTINE]: [
    { id: 'ask_community', label: 'Ask the Community', iconName: 'MessageCircle', action: 'open-create-post', postType: 'psa', primary: true },
  ],
  [AI_INTENTS.LOST_PET]: [
    { id: 'post_lost_pet', label: 'Post Lost Pet', iconName: 'PenSquare', action: 'open-create-post', postType: 'lost', primary: true },
  ],
  [AI_INTENTS.FOUND_PET]: [
    { id: 'post_found_pet', label: 'Post Found Pet', iconName: 'PenSquare', action: 'open-create-post', postType: 'found', primary: true },
  ],
  [AI_INTENTS.FIND_SERVICE]: [
    { id: 'post_service_request', label: 'Post Service Request', iconName: 'PenSquare', action: 'open-create-post', postType: 'petService', primary: true },
  ],
  [AI_INTENTS.FIND_PLACE]: [],
  [AI_INTENTS.COMMUNITY_QUESTION]: [
    { id: 'ask_community', label: 'Ask the Community', iconName: 'MessageCircle', action: 'open-create-post', postType: 'psa', primary: true },
  ],
  [AI_INTENTS.WEATHER_HAZARD]: [],
  [AI_INTENTS.OFF_TOPIC]: [],
  [AI_INTENTS.UNKNOWN]: DEFAULT_ACTIONS,
};

export function getActionsFor(intent) {
  if (intent === null || intent === undefined) return DEFAULT_ACTIONS;
  if (intent === AI_INTENTS.UNKNOWN) return DEFAULT_ACTIONS;

  const actions = INTENT_TO_ACTIONS[intent];
  if (actions) return actions;

  assertKnownIntent(intent);
  return DEFAULT_ACTIONS;
}
